import { api } from '@/services/api';

const PATH = 'oauth2/firebase';

interface GetFirebaseTokenResponse {
  access_token: string;
  expires_in: number;
  token_type: 'Bearer';
}

export const getFirebaseToken = async (): Promise<GetFirebaseTokenResponse> => {
  return api.get(PATH).json<GetFirebaseTokenResponse>();
};
